import React, { Component } from 'react';
import { PaymentItem } from './';

import { Loader } from '../../common/elements';

class PaymentList extends Component {

    render() {

        const { items, prices, content, removeItem } = this.props;

        if( !items.length ) return <Loader />;

        return (
            <div className="previewList">
                {
                    items.map( ( item, index ) => {
                        const _price = prices.filter( price => price.id === item.id )[ 0 ];
                        const _content = content.filter( content => content.id === item.id )[ 0 ];

                        return (
                            <div key={ index }>
                                <PaymentItem
                                    id={ _content.id }
                                    name={ _content.name }
                                    price={ _price.price }
                                />
                                {
                                    removeItem && <a onClick={ () => removeItem( _content.id ) }>Remove Item</a>
                                }
                            </div>
                        );
                    } )
                }
            </div>
        );

    };
}

export default PaymentList;



// WEBPACK FOOTER //
// src/client/components/common/transactions/PaymentList.js